import { render, staticRenderFns } from "./ConceptProductDetailOverall.vue?vue&type=template&id=b4d608c4&"
import script from "./ConceptProductDetailOverall.vue?vue&type=script&lang=js&"
export * from "./ConceptProductDetailOverall.vue?vue&type=script&lang=js&"
import style0 from "./ConceptProductDetailOverall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports